import 'dayjs/locale/de';
import localeDatePickerDe from 'antd/es/date-picker/locale/de_DE';

export default localeDatePickerDe;
